export const styles = {
  titleBlock: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: '30px',
    '& div ': {
      '& img': {
        position: 'relative',
        top: 0,
        right: 0,
        cursor: 'pointer',
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignPerforming/styles.js